import React from "react";

function SignUpAndLogin() {
  return (
    <div className="SignUpAndLoginContianer">
      <div>
        <div>
          <div className=" NationalBody">
            <a
              href="https://www.unilagalumniassociation.org"
              className="ClickLink"
            >
              Visit Our National Body
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpAndLogin;
